import * as yup from "yup";
import { PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

let createRiderValidationForm = yup.object().shape({
  user: yup.string().required("User is required"),
  license_number: yup.string().required("License Number is required"),
  branch: yup.string().required("Branch is required"),
  citizen_ship_number: yup.string().required("Citizenship Number is required"),
});
let editRiderVaidationForm = yup.object().shape({
  full_name: yup.string().required("User is required"),
  username: yup.string().required("License Number is required"),
  email: yup.string().required("Branch is required"),
  mobile_number: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  commission_type: yup
    .string()
    .oneOf(["flat", "percentage"])
    .required("Commission type is required"),
  commission: yup
    .string()
    .test(
      "typeError",
      "Invalid Commission rate. Must be a number",
      function (value) {
        return !isNaN(Number(value));
      }
    )
    .when("commission_type", {
      is: (value: string) => value === "flat",
      then: (schema) =>
        schema.test(
          "isPostive",
          "Commission rate must be positive",
          (value) => {
            return Number(value) >= 0;
          }
        ),
      otherwise: (schema) =>
        schema
          .test("isPostive", "Commission rate must be positive", (value) => {
            return Number(value) >= 0;
          })
          .test(
            "isLessThan100",
            "Commission rate must be less than 100%",
            (value) => {
              return Number(value) <= 100;
            }
          )
          .required("Commission rate is required"),
    }),
});
let changePasswordValidationForm = yup.object().shape({
  password: yup.string().required("Password is required"),
  confirm_password: yup
    .string()
    .oneOf([yup.ref("password"), ""], "Passwords don't match!")
    .required("Required"),
});
export {
  createRiderValidationForm,
  changePasswordValidationForm,
  editRiderVaidationForm,
};
